var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bdd-application-list"},[_c('app-table-header',{attrs:{"filter-text":_vm.filterText,"grouping":_vm.grouping,"filters":_vm.filters,"uri":_vm.uri},on:{"handle-search-filter":_vm.handleSearchFilter,"switchGrouping":_vm.switchGrouping}}),_c('app-table-content',{attrs:{"data":_vm.filteredData,"grouping":_vm.grouping}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }